import { PieChartOutlined, PullRequestOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import { Button, Tag } from "antd";
import { toJalaali } from "jalaali-js";
import moment from "moment/moment";
import ExportExcel from "../../../../Util/ExportExcel";
import CheckPermission from "../../../../Util/CheckPermission";

const ConsultingRequestsReport = ({
  LoadingSetter,
  ClearLoading,
  loading,
  permissions,
}) => {
  const [data, setData] = useState([]);

  const columns = [
    {
      title: "شماره تلفن",
      dataIndex: "mobile",
      searchable: true,
    },
    {
      title: "نام و نام خانوادگی",
      dataIndex: "name",
      searchable: true,
    },
    {
      title: "تعداد درخواست",
      dataIndex: "count",
      sorter: (a, b) => {
        return +b.count - +a.count;
      },
    },
    {
      title: "وضعیت ثبت نام",
      dataIndex: "signup_status",

      filters: [
        { value: false, text: "ثبت در خواست بدون ورود" },
        { value: true, text: "ثبت درخواست بعد از ورود" },
      ],
      onFilter: (value, record) => {
        return value === record.signup_status;
      },
      render: (text, record) => {
        switch (text) {
          case false:
            return <Tag color="red">ثبت در خواست بدون ورود</Tag>;
          case true:
            return <Tag color="green">ثبت درخواست بعد از ورود</Tag>;
          default:
            return text;
        }
      },
    },
    {
      title: "تاریخ ثبت",
      dataIndex: "createdAt",
      sorter: (a, b) => {
        const Adate = new Date(a.createdAt);
        const Bdate = new Date(b.createdAt);

        return Bdate - Adate;
      },
      render: (text, record) => {
        const date = new Date(text);
        if (moment(date).isValid()) {
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "توضیحات",
      dataIndex: "description",
    },
    {
      title: "آدرس درخواست",
      dataIndex: "referer",

      render: (text, record) => {
        return (
          <a style={{ maxWidth: "10rem" }} href={text} target="_blank">
            {text}
          </a>
        );
      },
    },
  ];
  const loadData = () => {
    LoadingSetter();
    api
      .get("/userrequests/list")
      .then((res) => {
        const uni = [];
        let data = [];
        res.data
          .sort((a, b) => {
            const aDate = new Date(a.createdAt);
            const bDate = new Date(b.createdAt);
            return bDate - aDate;
          })
          .forEach((user) => {
            console.log(user.mobile);
            const mobile = user.mobile ? user.mobile : user.user;
            if (!uni.includes(mobile)) {
              uni.push(mobile);
              data.push({
                ...user,
                mobile,
                signup_status: user.user ? true : false,
                count: 1,
              });
            } else {
              data = data.map((val) => {
                if (mobile === val.mobile) {
                  return {
                    ...val,
                    count: val.count ? val.count + 1 : 1,
                  };
                } else {
                  return val;
                }
              });
            }
          });
        setData(data);
        ClearLoading();
        console.log(data);
      })

      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  useEffect(() => {
    loadData();
    // loadFlagsData();
  }, []);
  const exportData = () => {
    const json = data.map((user) => {
      const newUser = {};
      Object.keys(user).forEach((key) => {
        let title = null;
        columns.forEach((c) => {
          if (c.dataIndex === key) {
            title = c.title;
          }
        });
        if (title) {
          newUser[title] = user[key];
        }
      });
      return newUser;
    });
    ExportExcel(json, "گزارش درخواست مشاوره");
  };
  return (
    <>
      <DataTable
        id="UsersReport"
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        recordCreatorDisabled
        header={{
          title: "درخواست مشاوره",
          avatar: { icon: <PullRequestOutlined />, size: "large" },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultingRequestsReport);
